import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function replaceStrVar(
    str: string,
    data: Record<string, any> = {},
    pattern = /\$\{[A-Za-z0-9_]+\}/g,
  ): string {
    let newStr = str;
    let result = pattern.exec(newStr);
    while (result !== null) {
      const varName = result[0].replace("${", "").replace("}", "");
      newStr = newStr.split(result[0]).join(data[varName] || "");
      result = pattern.exec(newStr);
    }
    return newStr;
  }

  return {
    replaceStrVar,
  };
}
